import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isInitializing: false,
  isLoading: false,
  error: null,
  schedules: [],
};

const slice = createSlice({
  name: 'payment-schedules',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      if (!state.schedules || state.schedules.length === 0) {
        state.isInitializing = true;
      }
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.isInitializing = false;
    },

    getPaymentSchedulesSuccess(state, action) {
      state.isLoading = false;
      state.schedules = action.payload;
      state.isInitializing = false;
    },
  },
});

export const { startLoading, hasError, getPaymentSchedulesSuccess } = slice.actions;

export default slice.reducer;
